import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const AddItemSubCat = ({ show, onClose, category,refresh ,onSuccess }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [subCatName, setSubCatName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [capsLockOn, setCapsLockOn] = useState(false);

  const handleKeyDown = (e) => {
    const caps = e.getModifierState && e.getModifierState('CapsLock'); 
    setCapsLockOn(caps);
  };

  const handleCreate = async () => {
    if (!subCatName.trim()) {
      setError('Sub Category Name is required');
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${baseURL}/item-subcategories`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          itemcategory_id: category.sno,
          itemsubcategory_name: subCatName,
          description,
        }),
      });

      if (!response.ok) {
        const errData = await response.json();
        setError(errData.message || 'Failed to create subcategory');
        setLoading(false);
        return;
      }

      setLoading(false);
      setSubCatName('');
      setDescription(''); 
      onClose(); 
      if (onSuccess) onSuccess();
    } catch (e) {
      setError('Network error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Modal show={show} size="md" onHide={onClose} backdrop="static" keyboard={!loading}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Create Item Sub Category</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose} disabled={loading}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 mb-3">
              <div className="row">
                <label className="col-12 text-black fs-7">Category</label>
                <label className="col-12 text-red font-w500 fs-4">
                  {category ? category.itemcategory_name : 'Loading...'}
                </label>
              </div>
            </div>

            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">
                Item Sub Category <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Item Sub Category"
                value={subCatName} 
                onChange={(e) => setSubCatName(e.target.value)}
                onKeyDown={handleKeyDown}
                onKeyUp={handleKeyDown}
                disabled={loading}
              />
              {capsLockOn && (
                <small style={{ color: 'orange' }}>Caps Lock is ON</small>
              )}
              {error && <div className="text-danger mb-2">{error}</div>}
            </div>

            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Description</label>
              <textarea
                rows={8}
                className="form-control"
                name="comment"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                disabled={loading}
              />
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
            <Button variant="secondary" size="sm" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={handleCreate} disabled={loading}>
              {loading ? 'Creating...' : 'Create Item Sub Category'}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddItemSubCat;
